<template>
  <!-- 选择商品弹窗 -->
  <div class="bigbox">
    <el-dialog :visible.sync="isShowCrowdDialog" title="生成人群" width="600px">
      <el-form :model="crowdForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="人群名称：" prop="name" required>
          <el-input v-model="crowdForm.name" placeholder="请输入" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="人群描述：" prop="description" required>
          <el-input v-model="crowdForm.description" placeholder="请输入" maxlength="50" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div style="display:flex;margin-left:100px;padding:10px;background:#fff9f9;line-height:20px;">
        <div><i class="el-icon-info" :style="{color:globalBG}"></i></div>
        <div style="margin-left:10px;">
          <p>1.生成的人群会保存在客户分群列表中；</p>
          <p>2.订单人数系统只会识别已购会员、品牌会员、0元开卡会员，其他维度的用户PIN会被去除；</p>
          <p>3.如勾选的订单购买用户一致，系统会自动去重。</p>
        </div>
      </div>
      <div style="text-align:right;margin-top:20px;">
        <el-button type="primary" style="width:auto" @click='save(1)' v-loading='btnLoading'>生成人群并去营销</el-button>
        <el-button type="primary" @click='save(2)' v-loading='btnLoading'>确认生成</el-button>
        <el-button @click="$emit('update:isShowCrowdDialog',false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addCrowd } from "@/api/tbOrder";
import { mapState, mapMutations } from "vuex";
export default {
  name: "crowd-dialog",
  props: {
    isShowCrowdDialog: {
      type: Boolean,
      default: false,
    },
    selectIdsArr: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      crowdForm: {
        name: '',
        description: '',
      },
      btnLoading: false,
    };
  },
  created() {
    console.log(this.selectIdsArr,111)
  },
  methods: {
    save(type) {
      if(!this.crowdForm.name) {
        return this.$message.warning('请输入人群名称')
      }else if(!this.crowdForm.description) {
        return this.$message.warning('请输入人群描述')
      }
      let obj = {
        ...this.selectIdsArr,
        ...this.crowdForm
      }
      this.btnLoading = true
      addCrowd(obj).then(res=>{
        this.btnLoading = false
        if(res.code == 1) {
          this.$message.success(res.message)
          this.$emit('update:isShowCrowdDialog',false)
          if(type == 1) {
            // if(this.$decrypt.menuPermission(this.$store.state.route,'accurate_market')) {
              this.$router.push({name:'accurate_market'})
            // }
          }
        }else{
          this.$message.error(res.message)
        }
      }).catch(err=>{
        this.btnLoading = false
      })
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  watch: {

  },
  created() {},

};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__error{
  display: none;
}
</style>
